export function nl2br(text?: string) {
    return String(text).replace(/\n/g, '<br>')
}

export default {
    install(Vue: any) {
        Vue.prototype.$nl2br = nl2br
    },
}
